import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import './styles/tokens.css';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { vuetify } from './plugins/vuetify';
const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(vuetify);
app.mount('#app');
